import React, { useCallback, useEffect, useState } from "react";

import { adminLogin, checkAdminLogin, internalProjectSearch, uploadInternalProject, uploadProjectSource, downloadProject, getContainer, setContainer } from "../dashboardapi";

import { Box, Button, Center, Container, Divider, FormLabel, HStack, InputGroup, InputRightElement, Link, Table, Td, Text, Th, Tr, useToast, VStack } from "@chakra-ui/react"
import { ChakraProvider, Input, Image } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import Custheme from "./ChakraCustom";
import { MdError, MdOutlineFileUpload, MdLogin, MdSearch, MdOutlineCode, MdArrowCircleLeft, MdSettings } from "react-icons/md";
import { LuLayoutTemplate } from "react-icons/lu";

import styles from "./Admin.module.css"
import Templateadmin from "./Templates/Templateadmin"
import { useDropzone } from 'react-dropzone';
import { useNavigate } from "react-router-dom";
import { useTheme } from "../Themes/ThemeContext";

// const LoginAdmin = () => {
//     const [username, setUsername] = useState('admin')
//     const [password, setPassword] = useState('Nimda#5202')
//     const toast = useToast();

//     const login = () => {
//         console.log("I am triggered");
//         console.log(username);


//         adminLogin(username, password).then((res) => {
//             if (res.data) {
//                 localStorage.setItem("adminToken", res.data.token);
//             } else {
//                 toast({
//                     title: "Login failed",
//                     description: res.error.error,
//                     status: "error",
//                     duration: 2000,
//                     isClosable: "true"
//                 })
//             }
//         })
//     }

//     return (
//         // <Container>
//         //     <VStack gap="2" align={'start'} width="full">
//         //         <FormLabel>User Name</FormLabel>
//         //         <Input variant="outline" value={username} onChange={(e) => setUsername(e.target.value)} />
//         //         <FormLabel>Password</FormLabel>
//         //         <Input variant="outline" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
//         //         <Button onClick={login}>Login</Button>
//         //     </VStack>
//         // </Container>

//         <div className={styles.container}>
//             <div className={styles.loginCard}>
//                 <h1 className={styles.title}>Admin Panel</h1>
//                 <p className={styles.subtitle}>Sign in to manage the system</p>

//                 <div className={styles.form}>
//                     <div className={styles.inputGroup}>
//                         <label>Username</label>
//                         <input
//                             type="text"
//                             placeholder="username"
//                             value={username}
//                             onChange={(e) => setUsername(e.target.value)}
//                             required
//                         />
//                     </div>

//                     <div className={styles.inputGroup}>
//                         <label>Password</label>
//                         <input
//                             type="password"
//                             placeholder="••••••••"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             required
//                         />
//                     </div>

//                     <button onClick={login} className={styles.loginBtn}>
//                         Login
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }



//MARK:Upload Int-Project
const ProjectUpload = () => {
    const [clientname, setclientname] = useState('')
    const [projectFile, setprojectFile] = useState()
    const [projectLink, setprojectLink] = useState(null)
    const toast = useToast();

    const onDropFiles = useCallback((acceptedFiles) => {
        setprojectFile(acceptedFiles);
    }, []);

    const { getRootProps: getRootPropsFiles, getInputProps: getInputPropsFiles } = useDropzone({
        onDrop: onDropFiles,
        multiple: true
    });
    //MARK:Hardcoded
    const uploadProject = () => {
        uploadInternalProject(projectFile, clientname).then((res) => {
            if (res.data) {
                console.log(res.data.project_id);
                //dynamic host name
                const currHost = window.location.origin;
                console.log(currHost);
                var link = `${currHost}/${res.data.project_id}?token=${res.data.token}`;

                setprojectLink(link);
            } else {
                toast({
                    title: "Error uploading file",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    // Delete handler
    const handleDelete = () => {
        setprojectFile(null); // Removes the file from state
    };

    return (
        <Container pt={4} pr={10} pl={10} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontSize: "32px", fontWeight: "500" }}>Project Upload</p>
            </Box>
            <VStack gap="2" align={'start'} width="50%">

                <FormLabel>Upload project file (.tar.gz)</FormLabel>
                <Box {...getRootPropsFiles()} className={styles.dropzone}>
                    <Input  {...getInputPropsFiles()} variant="outline" type="file" onChange={(e) => onDropFiles(e.target.files[0])} height={"100%"} />
                    <p>Drag & drop .tar.gz files here, or click to select files</p>
                </Box>
                {projectFile && (
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" w="100%" p={4} border="1px solid var(--border)" borderRadius="md">
                        <VStack align="start" spacing={1} w="70%">
                            <Text fontSize={["md"]} fontWeight="500" wordBreak="break-word">{projectFile.name}</Text>
                            <Text fontSize="0.75rem" color="var(--text-secondary)">{(projectFile.size / 1024).toFixed(2)} KB</Text>
                        </VStack>

                        <Button variant="ghost" p={0} ml={2} onClick={handleDelete}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_45_3546)">
                                    <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_45_3546">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {/* <Image src="/images/Redesignpics/Dashboard/delete.png" alt="delete" boxSize={["20px", "18px"]} /> */}
                        </Button>
                    </Box>

                )}

                <FormLabel>Client Name</FormLabel>
                <Input border="1px solid var(--border)" outline="none" background="var(--input)" color="var(--input-text)" value={clientname} placeholder="Enter Client Name" onChange={(e) => setclientname(e.target.value)} />
                <Button marginTop={"20px"} onClick={uploadProject}>Upload Project</Button>

                {projectLink ? <InputGroup size='md'>
                    <Input
                        pr='4.5rem'
                        type={'text'}
                        value={projectLink}
                    />
                    <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='sm' onClick={() => { if (window.isSecureContext) { navigator.clipboard.writeText(projectLink) } }}>
                            Copy
                        </Button>
                    </InputRightElement>
                </InputGroup> : null}
            </VStack>
        </Container >
    );
}


//MARK:Upload Source Project
const SourceUpload = () => {
    const [projectId, setprojectId] = useState('')
    const [sourceFile, setsourceFile] = useState()
    const toast = useToast();

    const onDropFiles = useCallback((acceptedFiles) => {
        setsourceFile(acceptedFiles);
    }, []);

    const { getRootProps: getRootPropsFiles, getInputProps: getInputPropsFiles } = useDropzone({
        onDrop: onDropFiles,
        multiple: true
    });

    const uploadSource = () => {
        console.log(projectId, sourceFile)
        uploadProjectSource(sourceFile, projectId).then((res) => {
            if (res.data) {
                console.log(res.data.project_id)
                toast({
                    title: "Source uploaded",
                    description: res.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
            } else {
                toast({
                    title: "Error uploading file",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }
    // Delete handler
    const handleDelete = () => {
        setsourceFile(null); // Removes the file from state
    };

    return (
        <Container pt={4} pr={10} pl={10} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontSize: "32px", fontWeight: "500" }}>Upload Source Tex for Project</p>
            </Box>
            <VStack gap="2" align={'start'} width="50%">
                <FormLabel>Upload Project Source file (.tex)</FormLabel>
                <Box {...getRootPropsFiles()} className={styles.dropzone}>
                    <Input {...getInputPropsFiles()} variant="outline" type="file" onChange={(e) => onDropFiles(e.target.files[0])} height={"100%"} />
                    <p>Drag & drop .tex files here, or click to select files</p>
                </Box>
                {sourceFile && (
                    <Box display="flex" alignItems="center" justifyContent="space-between" w="100%" p={2} border="1px solid gray" borderRadius="md">
                        <VStack align="start" spacing={0} w="70%">
                            <Text fontSize="md" fontWeight="500">{sourceFile.name}</Text>
                            <Text fontSize="0.75rem" color="var(--border)">{(sourceFile.size / 1024).toFixed(2)} KB</Text>
                        </VStack>

                        <Button variant="ghost" p={0} ml={2} onClick={handleDelete}>
                            {/* <Image src="/images/Redesignpics/Dashboard/delete.png" alt="delete" boxSize="20px" /> */}
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_45_3546)">
                                    <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_45_3546">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Button>
                    </Box>

                )}


                <FormLabel>Project UUID</FormLabel>
                <Input border="1px solid var(--border)" outline="none" background="var(--input)" color="var(--input-text)" value={projectId} placeholder="Enter Project UUID" onChange={(e) => setprojectId(e.target.value)} />
                <Button marginTop={"20px"} onClick={uploadSource}>Upload Source Tex</Button>
            </VStack>
        </Container >
    );
}


//MARK:Project Search
const ProjectSearch = () => {
    const [searhTerm, setsearchTerm] = useState('')
    const [data, setdata] = useState(null)
    const toast = useToast()

    const searchProject = () => {
        setdata(null);
        internalProjectSearch(searhTerm).then((res) => {
            if (res.data) {
                setdata(res.data.data)
            } else {
                toast({
                    title: "Please enter valid search",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }
    const handleDownload = async (projId) => {
        try {
            const loadToast = toast({
                title: "Downloading Project...",
                description: "Please wait while we fetch the file contents.",
                status: "loading",
                duration: null,
                isClosable: true
            });
            const fData = await downloadProject(projId);
            toast.close(loadToast);
            //console.log(fData.data);

            if (!fData.data || !fData.data.content) {
                toast({
                    title: "File content is empty or invalid",
                    description: fData.data.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
                return;
            }
            const byteCharacters = atob(fData.data.content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Create blob
            const blob = new Blob([byteArray], { type: "application/zip" });
            //temporary link to trigger download
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fData.data.name; //file name from API
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            toast({
                title: "Download failed",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
            // console.error("Download failed", error);
        }
    };


    //MARK:Search result table
    const RenderTable = (props) => {
        const data = props.data;
        console.log(props.data);
        return (
            <ChakraProvider theme={Custheme}>
                <Box height={"600px"} w={"100%"} overflow={"auto"} mt={"20px"} mb={"30px"}>
                    <Table border={"1px"} borderColor="var(--border)"  >
                        <Tr position={"sticky"} top={"0"} zIndex={"1000"} bg={"black.500"} width={"100%"}>
                            <Th color={"white"}>Sl. No.</Th>
                            <Th color={"white"}>Project Name</Th>
                            <Th color={"white"}>Project ID</Th>
                            <Th color={"white"}>MASK ID</Th>
                            <Th color={"white"}>Created On</Th>
                            <Th color={"white"}>Internal Project</Th>
                            <Th color={"white"}>Link</Th>
                            <Th color={"white"}>Download</Th>
                        </Tr>
                        {data.map((i, j) => (<Tr>
                            {/* {console.log(i.is_internal)} */}
                            <Td>{j + 1}</Td>
                            <Td>{i.project_name}</Td>
                            <Td>
                                {i.uuids ? (
                                    <Button
                                        size='sm'
                                        onClick={() => {
                                            if (window.isSecureContext) {
                                                navigator.clipboard.writeText(i.uuids);
                                            }
                                        }}
                                    >
                                        Copy
                                    </Button>
                                ) : (
                                    <Box mx={"auto"}>N/A</Box>
                                )}
                            </Td>
                            <Td>
                                {i.mask_uuid ? (
                                    <Button
                                        size='sm'
                                        onClick={() => {
                                            if (window.isSecureContext) {
                                                navigator.clipboard.writeText(i.mask_uuid);
                                            }
                                        }}
                                    >
                                        Copy
                                    </Button>
                                ) : (
                                    <Box mx={"auto"}>N/A</Box>
                                )}
                            </Td>
                            <Td>{i.created_at}</Td>
                            <Td fontWeight={"bold"}>{i.internal_project ? "Yes" : "No"}</Td>
                            <Td>{i.link ? <Link mx={"auto"} href={i.link} isExternal><ExternalLinkIcon /></Link> : <Box mx={"auto"}><MdError /></Box>}</Td>
                            <Td>
                                {i.uuids ? (
                                    <Button
                                        size='sm'
                                        onClick={() => handleDownload(i.uuids)}
                                    >
                                        Download
                                    </Button>
                                ) : (
                                    <Box mx={"auto"}>N/A</Box>
                                )}
                            </Td>
                        </Tr>))}
                    </Table>
                </Box>
            </ChakraProvider>
        )
    }

    return (
        <Container pt={4} pr={10} pl={10} maxW={"100%"} maxH={"100vh"} height={"100vh"}  >
            <VStack maxW={"100%"} h={"90vh"} display={"flex"} alignItems={"flex-start"} justifyContent={"flex-start"} >
                <Box w={"100%"} marginBottom={10}>
                    <p style={{ fontSize: "32px", fontWeight: "500" }}>Project Search</p>
                </Box>
                <InputGroup size='md' width={"50%"} justifyContent={"start"} display={"flex"} flexDirection={"column"}>
                    <Input
                        borderColor="var(--border)"
                        pr='4.5rem'
                        type={'text'}
                        value={searhTerm}

                        placeholder='Enter Project Name'
                        onChange={(e) => setsearchTerm(e.target.value)}
                    />
                    <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='sm' onClick={searchProject}>
                            Search
                        </Button>
                    </InputRightElement>
                </InputGroup>
                {data ? <RenderTable data={data} /> : null}
            </VStack>
        </Container>
    )
}

//MARK:Container Manager
const ContainerManager = () => {
    const [containerName, setContainerName] = useState('');
    const toast = useToast();

    useEffect(() => {
        getContainer().then((res) => {
            if (res.data) {
                setContainerName(res.data.container);
            }
        });
    }, []);

    const handleSetContainer = () => {
        setContainer(containerName).then((res) => {
            if (res.data) {
                toast({
                    title: "Container updated",
                    description: "Container name has been updated successfully.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Update failed",
                    description: res.error ? res.error.error : "Something went wrong",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        });
    };

    return (
        <Container pt={4} pr={10} pl={10} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontSize: "32px", fontWeight: "500" }}>Manage Container</p>
            </Box>
            <VStack gap="2" align={'start'} width="50%">
                <FormLabel>Container Name</FormLabel>
                <Input
                    border="1px solid var(--border)"
                    outline="none"
                    background="var(--input)"
                    color="var(--input-text)"
                    value={containerName}
                    placeholder="Enter Container Name"
                    onChange={(e) => setContainerName(e.target.value)}
                />
                <Button marginTop={"20px"} onClick={handleSetContainer}>Set Container</Button>
            </VStack>
        </Container>
    );
};

const Admin = () => {
    const [isLoggedIn, setisLoggedIn] = useState(false);
    const [loginChecked, setloginChecked] = useState(false);
    const [selectedMenu, setselectedMenu] = useState(1);
    const navigate = useNavigate();
    const { theme } = useTheme()
    useEffect(() => {
        if (!isLoggedIn && !loginChecked) { checkLogin() };
    })

    const checkLogin = () => {
        checkAdminLogin().then((res) => {
            if (res.data) {
                console.log("Admin already logged in.")
                setisLoggedIn(true);
                setloginChecked(true);
            } else {
                setisLoggedIn(false)
                navigate("/loginnew/signin")
            }
        })
    }

    const buttons = [
        { id: 1, label: "Upload Internal Project", icon: <MdOutlineFileUpload iconSpacing="4px" size={24} /> },
        { id: 2, label: "Search Internal Project", icon: <MdSearch iconSpacing="4px" size={24} /> },
        { id: 3, label: "Templates", icon: <LuLayoutTemplate iconSpacing="4px" size={24} style={{ marginRight: "10px" }} /> },
        { id: 4, label: "Upload Source for Project", icon: <MdOutlineCode iconSpacing="4px" size={24} /> },
        { id: 5, label: "Container Manager", icon: <MdSettings iconSpacing="4px" size={24} /> },
    ];

    console.log(isLoggedIn);

    //MARK:Sidebar buttons left
    return (
        isLoggedIn &&
        <ChakraProvider toastOptions={{ defaultOptions: { position: "top" } }} theme={Custheme}>
            <VStack VStack >
                <HStack w={'100%'}>
                    <VStack alignSelf={'center'}
                        display={"flex"}
                        justifyContent={"flex-start"}
                        w={["40%", "30%", "20%"]} bg={"var(--bg-overlay)"} height={"100vh"} >

                        {/* <Button onClick={() => { setselectedMenu(0) }} width={'100%'} leftIcon={<MdLogin />} colorScheme='teal' variant='solid'>Login as Admin</Button> */}

                        <Box borderBottom="1px solid var(--border)" w="100%" height="80px">
                            <a href="/dashboard/myprojects">
                                <Image
                                    width={["100%", "90%"]}
                                    height="40px"
                                    mr={[28, 0, 0]}
                                    mt={4}
                                    objectFit="contain"
                                    src={theme === "dark" ? process.env.PUBLIC_URL + "/images/dark-logo.png" : "/images/white-logo.png"}
                                    alt="EditLatex"
                                />
                            </a>
                        </Box>

                        {buttons.map((btn) => (
                            <Button
                                key={btn.id}
                                onClick={() => setselectedMenu(btn.id)}
                                width="100%"
                                height={16}
                                padding="5%"
                                borderRadius={0}
                                leftIcon={btn.icon}
                                whiteSpace="normal"
                                bg={"var(--bg-overlay)"}
                                color="var(--text-primary)"
                                _hover={{ bg: "#1a1a1a", color: "white" }}
                                justifyContent="flex-start"
                                fontSize="14px"
                                iconSpacing="4px"
                                borderRight={selectedMenu === btn.id ? "6px solid var(--btn-bg)" : "6px solid transparent"}
                            >
                                {btn.label}
                            </Button>
                        ))}

                        <Button onClick={() => navigate("/dashboard/myprojects")} width={'100%'}
                            leftIcon={<MdArrowCircleLeft iconSpacing="4px" size={22} />}
                            bg={"var(--bg-overlay)"}
                            color="var(--text-primary)"
                            _hover={{ bg: "#1a1a1a", color: "white" }}
                            borderRadius={0}
                            height={16}
                            padding="4%"
                            marginTop={"auto"}
                            whiteSpace="normal"
                            justifyContent="flex-start"
                        >Back to Projects</Button>
                    </VStack>

                    <Container maxW={"100%"} margin={0} height={"100vh"} overflowY={"hidden"} >
                        {/* {selectedMenu === 0 && !isLoggedIn ? <LoginAdmin /> : <Text>Already logged in.</Text>} */}

                        <div style={{
                            width: "100%",
                            height: "80px",
                            fontFamily: "Inter",
                            paddingTop: "9px", paddingLeft: "40px", paddingRight: "20px",
                            borderBottom: "1px solid var(--border)",
                            fontSize: ["38px"], fontWeight: "500"
                        }}>Admin Panel</div>

                        {selectedMenu === 1 && isLoggedIn ? <ProjectUpload /> : null}
                        {selectedMenu === 2 && isLoggedIn ? <ProjectSearch /> : null}
                        {selectedMenu === 3 && isLoggedIn ? <Templateadmin /> : null}
                        {selectedMenu === 4 && isLoggedIn ? <SourceUpload /> : null}
                        {selectedMenu === 5 && isLoggedIn ? <ContainerManager /> : null}
                    </Container>
                </HStack>
            </VStack >
        </ChakraProvider>
    );
};

export default Admin
